import * as Yup from "yup";

const updatePropertySchema = (updateScreen) => {
  if (updateScreen) {
    return {
      securityId: Yup.string().nullable().required("Please enter security id"),
    };
  } else {
    return {};
  }
};

const PROPERTY_NAME_REGEX =
  /^(?!\d+$)(?!\s+$)[a-zA-Z0-9\s]+[a-zA-Z]+[a-zA-Z0-9\s]*$/;

export const AddPropertySchema = (handleValidation, updateScreen) =>
  Yup.object({
    propertyName: Yup.string()
      .required("Property name is required")
      .matches(
        PROPERTY_NAME_REGEX,
        "Name contain alphabets or alphanumeric value"
      )
      .max(100, "Property name should be shorter than 100 characters"),
    propertyImages: Yup.object()
      .nullable()
      .shape({
        files: Yup.mixed().test(
          "required",
          "Please select file",
          (value) => value && value.length
        ),
      }),
    bedrooms: Yup.string().matches(/^[0-9]+$/, "Value must be a integer"),
    bathrooms: Yup.string().matches(/^[0-9]+$/, "Value must be a integer"),
    propertyArea: Yup.number()
      .typeError("Input value should be a number")
      .min(0, "Area must be greater or equal to 0")
      .required("Property area is required"),
    yearOfConstruction: Yup.string().matches(
      /\b\d{4}\b/,
      "Value must be a valid year"
    ),
    minimumPurchase: Yup.number()
      .typeError("Input value should be a number")
      .min(0, "Price must be greater than 0")
      .required("Minimum Purchase Price is required"),
    description: Yup.string().required("Property description is required"),
    propertyType: Yup.string()
      .nullable()
      .required("Please select property type"),
    city: Yup.string().nullable().required("Please select the city"),
    state: Yup.string().nullable().required("Please select the state"),
    avgRentTime: Yup.number()
      .typeError("Input value should be a number")
      .min(0, "Price must be greater than 0")
      .required("Rent time is required"),
    rentPerNight: Yup.string()
      .when("propertyType", {
        is: (e) => {
          if (handleValidation(e) === "Vacation rental") return e;
        },
        then: Yup.string().required("Rent per night is required"),
      })
      .matches(/^(\d+(\.\d+)?|)$/, "Value must be a number"),
    purchasePrice: Yup.number()
      .typeError("Input value should be a number")
      .min(0, "Price must be greater than 0")
      .required("Purchase price is required"),
    latitude: Yup.string()
      .required("Latitude is required")
      .matches(
        /^(?=.)-?((8[0-5]?)|([0-7]?[0-9]))?(?:\.[0-9]{1,20})?$/,
        "Please enter valid latitude"
      ),
    streetAddress: Yup.string().required("Street Address is required"),
    zipCode: Yup.string()
      .required("Zip Code is required")
      .matches(/^[0-9]{5}(?:-[0-9]{4})?$/, "Please enter valid Zip code"),
    longitude: Yup.string()
      .required("Longitude is required")
      .matches(
        /^(?=.)-?((0?[8-9][0-9])|180|([0-1]?[0-7]?[0-9]))?(?:\.[0-9]{1,20})?$/,
        "Please enter valid longitude"
      ),
    averageMonthlyRental: Yup.string()
      .when("propertyType", {
        is: (e) => {
          if (handleValidation(e) !== "Vacation rental") return e;
        },
        then: Yup.string().required("Monthly rent is required"),
      })
      .matches(/^(\d+(\.\d+)?|)$/, "Value must be a number"),
    amenities: Yup.array().nullable().of(Yup.number().required("is required")),
    propertyStatus: Yup.string()
      .nullable()
      .required("Please select property status"),
    occupancyRate: Yup.number()
      .typeError("Input value should be a percentage")
      .min(0, "Value must be a valid percentage")
      .max(100, "Value must be a valid percentage")
      .required("is required"),
    firstDividendYield: Yup.number()
      .typeError("Input value should be a percentage")
      .min(0, "Value must be a valid percentage")
      .max(100, "Value must be a valid percentage")
      .required("Dividend yield is required"),
    duration: Yup.string()
      .matches(
        /^$|^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
        'Date must be in "MM/DD/YYYY" format'
      )
      .required("Please select duration"),
    equityRaised: Yup.number()
      .typeError("Input value should be a number")
      .min(0, "Amount must be 0 or greater than 0")
      .required("is required"),
    expectedFirstDividend: Yup.string()
      .matches(
        /^$|^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
        'Date must be in "MM/DD/YYYY" format'
      )
      .required("Please select dividend date"),
    brokerDescription: Yup.string().required(
      "Management partner description is required"
    ),
    brokerName: Yup.string()
      .when("propertyType", {
        is: (e) => {
          if (handleValidation(e) === "Vacation rental") return e;
        },
        then: Yup.string().required("Broker name is required"),
      })
      .nullable(),
    managementPartnerName: Yup.string().required(
      "Management partner name is required"
    ),
    brokerDetails: Yup.string()
      .when("propertyType", {
        is: (e) => {
          if (handleValidation(e) === "Vacation rental") return e;
        },
        then: Yup.string().required("Broker details is required"),
      })
      .nullable(),
    marketDescription: Yup.string().required("Market description is required"),
    addMortageAmount: Yup.number()
      .typeError("Input value should be a number")
      .min(0, "Amount must be 0 or greater than 0")
      .required("Mortgage amount is required"),
    addMortageInterestRate: Yup.number()
      .typeError("Input value should be a number")
      .min(0, "Amount must be 0 or greater than 0")
      .max(100, "Rate must be a valid percentage")
      .required("Mortage interest rate is required"),
    addIPOSharePrice: Yup.number()
      .typeError("Input value should be a number")
      .min(0, "Price must be greater than 0")
      .required("Share price is required"),
    addTotalNoOfShares: Yup.string().matches(
      /^[0-9]+$/,
      "Value must be a integer"
    ),
    addImprovements: Yup.number()
      .typeError("Input value should be a number")
      .min(0, "Amount must be 0 or greater than 0")
      .required("Improvements is required"),
    addClosingsOfferingsAndHoldingCost: Yup.number()
      .typeError("Input value should be a number")
      .min(0, "Cost must be greater than 0")
      .required("is required"),
    addRealbricksSourcingFees: Yup.number()
      .typeError("Input value should be a number")
      .min(0, "Fees must be greater than 0")
      .required("Sourcing fees is required"),
    addRealBricksAUMFee: Yup.number()
      .typeError("Input value should be a number")
      .min(0, "Fees must be greater than 0")
      .required("AUM fees is required"),
    tag: Yup.string().nullable(),
    listPropertyOnSecondaryMarket: Yup.boolean(),
    locality: Yup.string().required("Locality is required"),
    marketName: Yup.string()
      .required("Market name is required")
      .max(255, "Market name should be shorter than 255 characters"),
    // leverage: Yup.number()
    //   .typeError('Input value should be a number')
    //   .min(0, 'Leverage must be greater or equal to 0')
    //   .max(100, 'Leverage must be less or equal 100')
    //   .required('is required'),
    addRealBricksAUMFeePurchase: Yup.number()
      .typeError("Input value should be a percentage")
      .min(0, "Value must be a valid percentage")
      .max(100, "Value must be a valid percentage")
      .required("AUM fees purchase rate is required"),
    // addRealBricksAUMFeeGrossRent: Yup.number()
    //   .typeError("Input value should be a percentage")
    //   .min(0, "Value must be a valid percentage")
    //   .max(100, "Value must be a valid percentage")
    //   .required("Gross rent is required"),
    // addPropertyManagementFees: Yup.number()
    //   .typeError('Input value should be a number')
    //   .min(0, 'Percentage must be greater or equal to 0')
    //   .max(100, 'Percentage must be less or equal 100')
    //   .required('is required'),
    lowAppreciation: Yup.number().typeError("Input value should be a number"),
    lowDividend: Yup.number().typeError("Input value should be a number"),
    averageAppreciation: Yup.number().typeError(
      "Input value should be a number"
    ),
    averageDividend: Yup.number().typeError("Input value should be a number"),
    highAppreciation: Yup.number().typeError("Input value should be a number"),
    highDividend: Yup.number().typeError("Input value should be a number"),
    unitCount_1: Yup.string().matches(/^$|^[0-9]+$/, "Value must be a integer"),
    unitCount_2: Yup.string().matches(/^$|^[0-9]+$/, "Value must be a integer"),
    unitCount_3: Yup.string().matches(/^$|^[0-9]+$/, "Value must be a integer"),
    unitCount_4: Yup.string().matches(/^$|^[0-9]+$/, "Value must be a integer"),
    unitCount_5: Yup.string().matches(/^$|^[0-9]+$/, "Value must be a integer"),
    unitCount_studio: Yup.string().matches(
      /^$|^[0-9]+$/,
      "Value must be a integer"
    ),
    avgSqrFt_1: Yup.string().matches(
      /^(\d+(\.\d+)?|)$/,
      "Value must be a number"
    ),
    avgSqrFt_2: Yup.string().matches(
      /^(\d+(\.\d+)?|)$/,
      "Value must be a number"
    ),
    avgSqrFt_3: Yup.string().matches(
      /^(\d+(\.\d+)?|)$/,
      "Value must be a number"
    ),
    avgSqrFt_4: Yup.string().matches(
      /^(\d+(\.\d+)?|)$/,
      "Value must be a number"
    ),
    avgSqrFt_5: Yup.string().matches(
      /^(\d+(\.\d+)?|)$/,
      "Value must be a number"
    ),
    avgSqrFt_studio: Yup.string().matches(
      /^(\d+(\.\d+)?|)$/,
      "Value must be a number"
    ),
    percentage_1: Yup.string().matches(
      /^(100(?:\.0{1,2})?|[0-9]?[0-9](?:\.[0-9]{1,2})?|\s*)?$/,
      "Value must be a valid percentage"
    ),
    percentage_2: Yup.string().matches(
      /^(100(?:\.0{1,2})?|[0-9]?[0-9](?:\.[0-9]{1,2})?|\s*)?$/,
      "Value must be a valid percentage"
    ),
    percentage_3: Yup.string().matches(
      /^(100(?:\.0{1,2})?|[0-9]?[0-9](?:\.[0-9]{1,2})?|\s*)?$/,
      "Value must be a valid percentage"
    ),
    percentage_4: Yup.string().matches(
      /^(100(?:\.0{1,2})?|[0-9]?[0-9](?:\.[0-9]{1,2})?|\s*)?$/,
      "Value must be a valid percentage"
    ),
    percentage_5: Yup.string().matches(
      /^(100(?:\.0{1,2})?|[0-9]?[0-9](?:\.[0-9]{1,2})?|\s*)?$/,
      "Value must be a valid percentage"
    ),
    percentage_studio: Yup.string().matches(
      /^(100(?:\.0{1,2})?|[0-9]?[0-9](?:\.[0-9]{1,2})?|\s*)?$/,
      "Value must be a valid percentage"
    ),
    multiFamilyUnitOccupied: Yup.string()
      .matches(/^$|^[0-9]+$/, "Value must be a integer")
      .nullable(),
    // propertyMgmtFeesMin: Yup.string().required("Property Management fees is required")
    //   // .when("propertyType", {
    //   //   is: (e) => {
    //   //     if (handleValidation(e) === "Vacation rental") return e;
    //   //   },
    //   //   then: Yup.string().required("Min. Management fees is required"),
    //   // })
    //   .matches(
    //     /^(100(?:\.0{1,2})?|[0-9]?[0-9](?:\.[0-9]{1,2})?|\s*)?$/,
    //     "Value must be a valid percentage"
    // ),
    propertyMgmtFeesMin: Yup.number()
      .typeError("Input value should be a percentage")
      .min(0, "Value must be a valid percentage")
      .max(100, "Value must be a valid percentage")
      .required("Property Management fees is required"),
    // propertyMgmtFeesMax: Yup.string()
    //   .when("propertyType", {
    //     is: (e) => {
    //       if (handleValidation(e) === "Vacation rental") return e;
    //     },
    //     then: Yup.string().required("Max. Management fees is required"),
    //   })
    //   .matches(
    //     /^(100(?:\.0{1,2})?|[0-9]?[0-9](?:\.[0-9]{1,2})?|\s*)?$/,
    //     "Value must be a valid percentage"
    //   ),
    ...updatePropertySchema(updateScreen),
  });
